import { filterCommissions } from 'bundles/backoffice/vouchers/helpers/commissions';

export function getBrokerageGrossCommissionAmount(deal, transactionSide) {
  const details = deal.transactionSideDetails.find(details => details.transactionSide === transactionSide);
  return details.grossAmount - filterCommissions(deal.commissions, transactionSide, true).reduce((sum, commission) => {
    return commission.grossAmount + sum;
  }, 0);
}
